import { useEffect } from 'react';
import { SITE_URL } from '../lib/site';
import { LANGS } from '../i18n';

function upsertMeta(attr, key, content) {
    if (!content) return;
    let el = document.head.querySelector(`meta[${attr}="${key}"]`);
    if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, key);
        document.head.appendChild(el);
    }
    el.setAttribute('content', content);
}

export default function SEO({ title, description, path = '/', lang = 'ms', ogType = 'website', jsonLd = [], image }) {
    useEffect(() => {
        const suffixPath = path === '/' ? '' : path;
        const url = `${SITE_URL}/${lang}${suffixPath}`;
        const locale = (LANGS.find((l) => l.code === lang) || {}).og || 'ms_MY';
        document.documentElement.lang = lang;
        document.title = title;
        upsertMeta('name', 'description', description);
        let canon = document.head.querySelector('link[rel="canonical"]');
        if (!canon) {
            canon = document.createElement('link');
            canon.rel = 'canonical';
            document.head.appendChild(canon);
        }
        canon.setAttribute('href', url);
        document.head.querySelectorAll('link[data-hreflang]').forEach((el) => el.remove());
        [...LANGS, { code: 'x-default' }].forEach((l) => {
            const link = document.createElement('link');
            link.rel = 'alternate';
            link.hreflang = l.code;
            link.href = `${SITE_URL}/${l.code === 'x-default' ? 'ms' : l.code}${suffixPath}`;
            link.setAttribute('data-hreflang', '1');
            document.head.appendChild(link);
        });
        upsertMeta('property', 'og:title', title);
        upsertMeta('property', 'og:description', description);
        upsertMeta('property', 'og:url', url);
        upsertMeta('property', 'og:type', ogType);
        upsertMeta('property', 'og:locale', locale);
        upsertMeta('property', 'og:image', image || `${SITE_URL}/img/og-default.jpg`);
        upsertMeta('name', 'twitter:card', 'summary_large_image');
        upsertMeta('name', 'twitter:title', title);
        upsertMeta('name', 'twitter:description', description);
        upsertMeta('name', 'twitter:image', image || `${SITE_URL}/img/og-default.jpg`);
        document.head.querySelectorAll('script[data-jsonld]').forEach((el) => el.remove());
        jsonLd.filter(Boolean).forEach((obj) => {
            const s = document.createElement('script');
            s.type = 'application/ld+json';
            s.setAttribute('data-jsonld', '1');
            s.textContent = JSON.stringify(obj);
            document.head.appendChild(s);
        });
    }, [title, description, path, lang, ogType, image, jsonLd]);
    return null;
}
